
import { createI18n } from 'vue-i18n'
import en from '@/texts/en'

// eslint-disable-next-line no-shadow
export enum LANG {
    EN = 'en',
    PL = 'pl',
}

export class TLI18n {
    i18n

    constructor(lang: LANG) {
        this.i18n = createI18n({
            legacy: false,
            locale: lang,
            fallbackLocale: 'en',
            messages: {
                en,
            },
        })
    }
}

let I18N_INSTANCE: null | TLI18n = null

export function resetI18nInstance() {
    I18N_INSTANCE = null
}

export function createTLI18n(lang: LANG) {
    if (I18N_INSTANCE) {
        console.warn('i18n service already created') // eslint-disable-line no-console
        return I18N_INSTANCE
    }

    I18N_INSTANCE = new TLI18n(lang)

    return I18N_INSTANCE
}

export function useI18n() {
    if (!I18N_INSTANCE) {
        throw new Error('i18n haven\'t been created')
    }

    return I18N_INSTANCE.i18n.global
}
